import axios from "axios";

function ListContactsSearch(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3041";
      axios
        .post(process.env.ROOT_API + "/contacts/id/list", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("ListContactsSearch: ", error);
    }
  });
}

function listPersonContact(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3043";
    axios
      .post(process.env.ROOT_API + "/contacts/persons/list", objData.body, {
        headers: {
          Authorization: objData.token
        }
      })
      .then(result => {
        resolve(result.data.documents);
      })
      .catch(error => {
        reject(error.response.data.message);
      });
  });
}

function listInstitutionContact(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3042";
    axios
      .post(
        process.env.ROOT_API + "/contacts/institutions/list",
        objData.body,
        {
          headers: {
            Authorization: objData.token
          }
        }
      )
      .then(result => {
        resolve(result.data.documents);
      })
      .catch(error => {
        reject(error.response.data.message);
      });
  });
}

function ContactsSearch(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3101";
      axios
        .put(process.env.ROOT_API + "/persons/agg/gender", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("ContactsSearch: ", error);
    }
  });
}
function ImagineSearch(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3099";
      axios
        .put(
          process.env.ROOT_API + "/imagings/agg/uploaded_sent",
          objAux.body,
          {
            headers: {
              Authorization: objAux.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("ImagineSearch: ", error);
    }
  });
}
function LaboratorySearch(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3100";
      axios
        .put(process.env.ROOT_API + "/laboratories/agg/uploaded", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("LaboratorySearch: ", error);
    }
  });
}
function UserSearch(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3016";
      axios
        .get(process.env.ROOT_API + "/users/search/" + objAux.user, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("UserSearch: ", error);
    }
  });
}
function MedicalSpecialties(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3143";
      axios
        .post(process.env.ROOT_API + "/specialities/query", objAux.body.name, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("ListContactsSearch: ", error);
    }
  });
}

function porcentageCompleted(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3159";
      axios
        .get(
          process.env.ROOT_API +
            "/porcentage_completed/" +
            objAux.type +
            "/" +
            objAux.id,
          {
            headers: {
              Authorization: objAux.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("ListContactsSearch: ", error);
    }
  });
}

function counterUpdated(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3161";
      axios
        .put(
          process.env.ROOT_API + "/counterOfVisit/update/" + objAux.id,
          objAux.body,
          {
            headers: {
              Authorization: objAux.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("ListContactsSearch: ", error);
    }
  });
}

function counterQuery(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3162";
      axios
        .get(process.env.ROOT_API + "/counterOfVisit/query/" + objAux.id, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error);
        });
    } catch (error) {
      console.log("ListContactsSearch: ", error);
    }
  });
}
function counterInsert(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3160";
      axios
        .post(process.env.ROOT_API + "/counterOfVisit/insert", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("ListContactsSearch: ", error);
    }
  });
}
function TotalesVC(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3160";
      axios
        .post(process.env.ROOT_API + "/vc/agg/total", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("TotalesVC: ", error);
    }
  });
}
function TotalesSemanalVC(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3160";
      axios
        .post(process.env.ROOT_API + "/vc/agg/total", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("TotalesSemanalVC: ", error);
    }
  });
}
function PorcentajesVC(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3160";
      axios
        .post(process.env.ROOT_API + "/vc/agg/countries", objAux.body, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("TotalesSemanalVC: ", error);
    }
  });
}
export {
  ListContactsSearch,
  listPersonContact,
  listInstitutionContact,
  ContactsSearch,
  ImagineSearch,
  UserSearch,
  LaboratorySearch,
  MedicalSpecialties,
  porcentageCompleted,
  counterUpdated,
  counterQuery,
  counterInsert,
  TotalesVC,
  TotalesSemanalVC,
  PorcentajesVC
};



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboradServ.js